module.exports = __webpack_public_path__ + "img/honor_8.66017a99.png";